import { render, staticRenderFns } from "./LoadingLogin.vue?vue&type=template&id=0024b07f&scoped=true"
import script from "./LoadingLogin.vue?vue&type=script&lang=js"
export * from "./LoadingLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024b07f",
  null
  
)

export default component.exports